import React from "react";
import { Link } from "react-router-dom";

const socialContent = [
  {
    icon: "fa-facebook",
    link: "https://www.facebook.com/Expozy-108019807443777/",
  },
  {
    icon: "fa-linkedin",
    link: "https://www.linkedin.com/in/expozy-limited-623baa199/",
  },
  {
    icon: "fa-telegram",
    link: "https://t.me/expozy",
  }
];

const CopyRightThree = () => {
  return (
    <div className="row">
    
      <div className="col-lg-6 order-lg-6 mb-20">
        <ul
          className=" d-flex social-icon"
        >
          {socialContent.map((val, i) => (
            <li key={i}>
              <a href={val.link} target="_blank" rel="noreferrer">
                <i className={`fa ${val.icon}`}></i>
              </a>
            </li>
          ))}
        </ul>
        {/* End .social-icon */}
      </div>
      <div className="col-lg-6 order-lg-6 mb-20">
        <p className="copyright text-center">
          Copyright @{new Date().getFullYear()}{" "}
          <a
            href=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Expozy
          </a>{" "}
          inc.
        </p>
      </div>
    </div>
  );
};

export default CopyRightThree;
